import jquery from 'jquery';
import Handlebars from "handlebars"

window.Handlebars = Handlebars
window.jQuery = jquery
window.$ = jquery

String.prototype.slugify = function (separator = "-") {
    return this
        .toString()
        .normalize('NFD')                   // split an accented letter in the base letter and the acent
        .replace(/[\u0300-\u036f]/g, '')   // remove all previously split accents
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 ]/g, '')   // remove all chars not letters, numbers and spaces (to be replaced)
        .replace(/\s+/g, separator);
};

Handlebars.registerHelper( "when",function(operand_1, operator, operand_2, options) {
    var operators = {
     'eq': function(l,r) { return l == r; },
     'noteq': function(l,r) { return l != r; },
     'gt': function(l,r) { return Number(l) > Number(r); },
     'or': function(l,r) { return l || r; },
     'and': function(l,r) { return l && r; },
     '%': function(l,r) { return (l % r) === 0; }
    }
    , result = operators[operator](operand_1,operand_2);

    if (result) return options.fn(this);
    else  return options.inverse(this);
});

Handlebars.registerHelper('greaterThan', function (v1, v2, options) {
  'use strict';
      if (v1>v2) {
        return options.fn(this);
    }
    return options.inverse(this);
});

Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

  switch (operator) {
      case '==':
          return (v1 == v2) ? options.fn(this) : options.inverse(this);
      case '===':
          return (v1 === v2) ? options.fn(this) : options.inverse(this);
      case '!=':
          return (v1 != v2) ? options.fn(this) : options.inverse(this);
      case '!==':
          return (v1 !== v2) ? options.fn(this) : options.inverse(this);
      case '<':
          return (v1 < v2) ? options.fn(this) : options.inverse(this);
      case '<=':
          return (v1 <= v2) ? options.fn(this) : options.inverse(this);
      case '>':
          return (v1 > v2) ? options.fn(this) : options.inverse(this);
      case '>=':
          return (v1 >= v2) ? options.fn(this) : options.inverse(this);
      case '&&':
          return (v1 && v2) ? options.fn(this) : options.inverse(this);
      case '||':
          return (v1 || v2) ? options.fn(this) : options.inverse(this);
      default:
          return options.inverse(this);
  }
});

// Shopify

/*
 * Simple helper to stringify an object.
 * Usage: {{ JSON2string object }}
 */
Handlebars.registerHelper('JSON2string', function (object) {
    return JSON.stringify(object);
});

/*
 * Shopify image sizer.
 * Usage: {{ imageSize imageObject Size }}
 */
Handlebars.registerHelper('imageSize', function (src, size) {

    if (src) {
        let f = src.substring(0, src.lastIndexOf('.'));
        let p = src.split('.').pop()
        return f + '_' + size + "." + p;
    }

});

/*
* Contains string
*/
Handlebars.registerHelper('contains', function(needle, haystack, options) {
    needle = Handlebars.escapeExpression(needle)
    haystack = Handlebars.escapeExpression(haystack);
    return (haystack.indexOf(needle) > -1) ? options.fn(this) : options.inverse(this)
});

/*
* Badge text augmentation (splitting)
*/
Handlebars.registerHelper('tagText', function (str) {
    str = str.split('_')
    return str[1]
});

/*
* Badge colour augmentation (to match tailwind css classes)
*/
Handlebars.registerHelper('tagColour', function (str, needle) {
        str = str.split('_')

        str = str[0].split(needle)
        if (str[1] == 'Black' || str[1] == 'White' || str[1] == 'Blue') {
            str[1] = 'Brand-' + str[1];
        }
        if (typeof str[1] !== 'undefined') {
            return str[1].toLowerCase()
        }
});

Handlebars.registerHelper('preOrderAttribute', function(string) {
    var t = string.split("_");
    return t[1];
  });